import React from "react";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import IconInstagram from "../Icons/IconInstagram";
import IconTwitter from "../Icons/IconTwitter";
import IconFacebook from "../Icons/IconFacebook";
import IconLinkedin from "../Icons/IconLinkedin";
import IconWhatsapp from "../Icons/IconWhatsapp";

const FollowUs = () => (
    <Container fluid tag="section" className="follow-us py-5">
        <Row>
            <Col xs="12" tag="article" className="text-center">
                <h3>Síguenos en nuestras redes</h3>
            </Col>
            <Col xs="12" tag="article" className="rr-ss text-center pt-5">
                <a href="http://instagram.com/thefmimadrid" target="_blank" rel="noreferrer">
                    <IconInstagram width={60} height={60} fill="#EAE0D8FF" />
                </a>
                <a href="https://twitter.com/fmimadrid" target="_blank" rel="noreferrer" className="ms-4">
                    <IconTwitter width={58} height={58} fill="#EAE0D8FF" />
                </a>
                <a href="https://www.facebook.com/The-Football-Management-Institute-123205137373997" target="_blank" rel="noreferrer" className="ms-4">
                    <IconFacebook width={55} height={55} fill="#EAE0D8FF" />
                </a>
                <a href="https://www.linkedin.com/company/92520377/admin/?feedType=following" target="_blank" rel="noreferrer" className="ms-4">
                    <IconLinkedin width={60} height={60} fill="#EAE0D8FF" />
                </a>
                <a href="https://web.whatsapp.com/send?phone=34676163368&text=" target="_blank" rel="noreferrer" className="ms-4">
                    <IconWhatsapp width={60} height={60} fill="#EAE0D8FF" />
                </a>
            </Col>
        </Row>
    </Container>
);

export default FollowUs;